import React from 'react'
import { Attributes, ConditionalShow, Label } from "../../modules/tp/builders/FormBuilder";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FormikProps } from "formik";

export type ButtonActionProps<T> = {
    formik: FormikProps<T>,
    inputObj: ButtonActionObj<T>
    entity: T,
}

export type ButtonActionObj<T> = {
    [key: string]: any,
    type: "buttonAction",
    key: keyof T,
    confirmation?: {
        title: string | JSX.Element,
        description: string | JSX.Element,
    } | false
    action: (entity: T) => (void | Promise<void>),
} & Attributes & Label & ConditionalShow<T>

const ButtonAction = <T,>({ formik, inputObj }: ButtonActionProps<T>) => {
    let { action, confirmation, label, showIf } = inputObj

    const [show, setShow] = React.useState(false);

    React.useEffect(() => {
        if (!showIf) {
            return setShow(true);
        }
        showIf((formik.values ?? {}) as T)
            .then((res: boolean) => setShow(res))
    }, [formik.values])

    if (!confirmation) {
        confirmation = false;
    }

    const [showPopover, setShowPopover] = React.useState(false);
    const entity = formik.values

    return (
        <div
            {
            ...inputObj.attributes
            }>
            {
                show ?
                    <>
                        {!!confirmation ?
                            <OverlayTrigger
                                trigger="click"
                                placement="right"
                                show={showPopover}
                                overlay={
                                    <Popover className="tp-popover">
                                        <Popover.Header as="h3" className="tp-popover-header">{confirmation.title}</Popover.Header>
                                        <Popover.Body className="tp-popover-body">
                                            <p><strong>{confirmation.description}</strong></p>
                                            <div className="tp-popover-buttons">
                                                <button
                                                    type="button"
                                                    className="btn tp-btn-secondary tp-btn-secondary-danger"
                                                    onClick={() => setShowPopover(false)} >
                                                    No
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => { action(entity); setShowPopover(false) }}
                                                    className="btn tp-btn-primary">
                                                    Si, procedi
                                                </button>
                                            </div>
                                        </Popover.Body>
                                    </Popover>
                                }>
                                <button
                                    type="button"
                                    onClick={() => setShowPopover(true)}
                                    className="btn tp-btn-primary"
                                >
                                    {label}
                                </button>
                            </OverlayTrigger>
                            :
                            <button
                                type="button"
                                onClick={() => action(entity)}
                                className="btn tp-btn-primary"
                                {
                                ...inputObj.attributes
                                }
                            >
                                {label}
                            </button>
                        }
                    </> : <></>
            }
        </div>
    )
};

export default ButtonAction;
